export default function downloadBlob(blobContent, filename, fileType) {
  const blob = new Blob([blobContent], { type: fileType })
  const url = URL.createObjectURL(blob)

  const downloadAnchor = document.createElement('a')
  downloadAnchor.href = url
  downloadAnchor.setAttribute('download', filename)
  downloadAnchor.click()
}
